(() => {
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount / 100);
  function updateShipping(cart, animate = true) {
    document.querySelectorAll('[data-shipping-meter]').forEach((meter) => {
      const threshold = Number(meter.dataset.threshold);
      if (!(threshold > 0) || !Number.isFinite(cart.total_price)) return;
      if (cart.currency && cart.currency !== meter.dataset.currency) { meter.hidden = true; return; }
      meter.hidden = false;
      const percent = Math.max(0, Math.min(100, cart.total_price / threshold * 100));
      const remaining = Math.max(0, threshold - cart.total_price);
      const label = meter.querySelector('[data-shipping-label]');
      const strong = document.createElement('strong');
      if (remaining > 0) {
        strong.textContent = money(remaining, meter.dataset.currency);
        label.replaceChildren(strong, document.createTextNode(' to complimentary shipping'));
      } else {
        strong.textContent = 'Complimentary shipping unlocked ✓';
        label.replaceChildren(strong);
      }
      meter.querySelector('[data-shipping-liquid]').style.width = `${percent}%`;
      meter.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(percent)));
      meter.querySelector('[role="progressbar"]').setAttribute('aria-valuetext', `${money(cart.total_price,meter.dataset.currency)} of ${money(threshold,meter.dataset.currency)}`);
      meter.querySelector('[data-shipping-amount]').textContent = `${money(cart.total_price,meter.dataset.currency)} of ${money(threshold,meter.dataset.currency)}`;
      meter.querySelector('[data-shipping-percent]').textContent = `${Math.round(percent)}% filled`;
      meter.classList.toggle('is-full',remaining === 0);
      if (animate && Number(meter.dataset.total) !== cart.total_price) meter.classList.add('is-filling');
      meter.dataset.total = String(cart.total_price);
    });
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      node.closest('.bag-button')?.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
    });
  }
  function initGlass(root = document) {
    root.querySelectorAll('[data-glass-shelf]').forEach((shelf) => {
      if (shelf.dataset.ready) return;
      shelf.dataset.ready = 'true';
      const track = shelf.querySelector('[data-shelf-track]');
      const prev = shelf.querySelector('[data-shelf-prev]');
      const next = shelf.querySelector('[data-shelf-next]');
      const controls = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = !overflow;
        next.hidden = !overflow;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      [prev, next].forEach((button, index) => button.addEventListener('click', () => {
        const card = track.querySelector('.shelf-item');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap) : track.clientWidth;
        track.scrollBy({ left: (index ? 1 : -1) * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', controls, { passive: true });
      const observer = new ResizeObserver(controls);
      observer.observe(track);
      shelf.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      controls();
    });
    root.querySelectorAll('[data-shipping-meter]').forEach((meter) => {
      if (meter.dataset.ready) return;
      meter.dataset.ready = 'true';
      meter.classList.toggle('is-full', Number(meter.dataset.total) >= Number(meter.dataset.threshold));
      meter.addEventListener('animationend', () => meter.classList.remove('is-filling'));
    });
  }
  async function refreshCart() {
    if (!document.querySelector('[data-shipping-meter]')) return;
    try {
      const response = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (response.ok) updateShipping(await response.json(), false);
    } catch { /* Preserve the server-rendered cart state when offline. */ }
  }
  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail?.cart || event.detail;
    if (!cart || !Number.isFinite(cart.total_price)) return;
    updateShipping(cart);
  });
  document.addEventListener('DOMContentLoaded', () => initGlass());
  document.addEventListener('shopify:section:load', (event) => initGlass(event.target));
  window.addEventListener('pageshow', refreshCart);
})();
